module.exports = {
  entities: (Api) ->
    (params) ->
      query =
        offset: params.offset
        limit: params.limit
        name: params.name
      return Api.Entity.query(query).$promise
}
